import {
  useDataIsSubmitting,
  useDataSubmit,
  useDataValue,
} from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'connection',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'connect-api-token' })
  }
}

export function useDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'connection',
    viewPath: props.viewPath,
  })
  let token = useDataValue({
    context: 'connection',
    path: 'token',
    viewPath: props.viewPath,
  })

  return isSubmitting || !token
}
